export default "__VITE_ASSET__DU26xxXC__"